import merge from 'deepmerge';

import type { Translations } from '../types';
import common from './common';
import customer from './customer';
import en from './en/web-itc.json';
import fr from './fr/web-itc.json';

const webItc = {
  fr: fr.web_itc,
  en: en.web_itc,
};

export default merge.all<Translations>([common, customer, webItc]);
